import { lazyWithRetry as lazy } from '@utils/lazyWithRetry';
import { RouteConfig } from './types';
import {
  EnterVerificationCode,
  GetVerificationCode,
} from '@component/VerificationCode';

const AuthorizationWrapper = lazy(() => import('@page/AuthorizationWrapper'));
const Login = lazy(() => import('@component/Login/Login'));
const Registration = lazy(() => import('@component/Registration/Registration'));
const ForgotPassword = lazy(
  () => import('@component/ForgotPassword/ForgotPassword')
);
const CheckEmail = lazy(() => import('@component/CheckEmail/CheckEmail'));
const ResetPassword = lazy(
  () => import('@component/ResetPassword/ResetPassword')
);
const CreatePassword = lazy(
  () => import('@component/CreatePassword/CreatePassword')
);
const PasswordChanged = lazy(
  () => import('@component/PasswordChanged/PasswordChanged')
);
const ExpiredLink = lazy(() => import('@component/ExpiredLink/ExpiredLink'));
const ExpiredLinkSms = lazy(
  () => import('@component/ExpiredLinkSms/ExpiredLinkSms')
);
const PageNotFound = lazy(() => import('@component/PageNotFound/PageNotFound'));
const PhoneUpload = lazy(
  () =>
    import('@component/ContractorPortal/Credentialing/PhoneUpload/PhoneUpload')
);

export const publicRoutes: RouteConfig[] = [
  // the one-time upload-from-phone link, opened without signing in
  { path: 'upload/:token', element: PhoneUpload },
  {
    path: 'authorization',
    element: AuthorizationWrapper,
    children: [
      { path: 'login', element: Login },
      { path: 'registration', element: Registration },
      { path: 'forgot-password', element: ForgotPassword },
      { path: 'check-email', element: CheckEmail },
      { path: 'get-verification-code', element: GetVerificationCode },
      { path: 'enter-verification-code', element: EnterVerificationCode },
      { path: 'reset-password', element: ResetPassword },
      { path: 'create-password', element: CreatePassword },
      { path: 'password-changed', element: PasswordChanged },
      { path: 'expired-link', element: ExpiredLink },
      { path: 'expired-link-sms', element: ExpiredLinkSms },
      { path: '*', element: PageNotFound },
    ],
  },
];
